import { z } from 'zod';

export const postPurchaseSuccessInfo = z.object({
  transactionId: z.string(),
  /** The payment intent the purchase settled under, the id the conversion APIs dedup the browser purchase by. */
  paymentIntentId: z.string().optional(),
  originalPrice: z.number(),
  finalPrice: z.number(),
  currency: z.string(),
  coupon: z.string().optional(),
  productId: z.string(),
  mode: z.enum(['payment', 'subscription', 'setup']),
  source: z.string(),
  isFreeTrial: z.literal(true).optional(),
  sku: z.string().optional(),
});

export type PostPurchaseSuccessInfo = z.infer<typeof postPurchaseSuccessInfo>;

type PostPurchaseSuccess = {
  success: true;
  returnPath: string;
  purchaseInfo: PostPurchaseSuccessInfo;
};

type PostPurchaseError = {
  success: false;
  returnPath: string;
};

export type PostPurchaseInfo = PostPurchaseSuccess | PostPurchaseError;
